import { render, staticRenderFns } from "./WellnessChart.vue?vue&type=template&id=16f8a0b4"
import script from "./WellnessChart.vue?vue&type=script&lang=js"
export * from "./WellnessChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports